var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAskGlyph = function SvgAskGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "url(#ask-glyph_svg__a)",
    fillOpacity: 0.3,
    stroke: "url(#ask-glyph_svg__b)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ask-glyph_svg__a",
    x1: 5.422,
    x2: 6.675,
    y1: 2,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6DCEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#5EBBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#B478E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5658C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ask-glyph_svg__b",
    x1: 5.422,
    x2: 6.675,
    y1: 2,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6DCEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#5EBBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#B478E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5658C"
  })))));
};
export default SvgAskGlyph;